import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {of, ReplaySubject} from "rxjs";
import {ReceivablesPaymentImportRow} from "../../../../shared/interface/receivables-payment-import-row";
import {MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {Router} from "@angular/router";
import {AuthService} from "../../../../shared/services/auth.service";
import {ReceivablesPaymentImportRowService} from "../../../../shared/services/receivables-payment-import-row.service";
import {delay, first, tap} from "rxjs/operators";
import {Uuid} from "../../../../shared/interface/response/uuid";
import {HttpErrorResponse} from "@angular/common/http";
import {UserPermissions} from "../../../../shared/interface/user-permissions";

@Component({
  selector: 'app-receivables-payment-import-transfer-add',
  templateUrl: './receivables-payment-import-transfer-add.component.html',
  styleUrls: ['./receivables-payment-import-transfer-add.component.scss']
})
export class ReceivablesPaymentImportTransferAddComponent implements OnInit, OnDestroy {

  userPermissions: ReplaySubject<UserPermissions>;

  userPermissionss: UserPermissions;
  receivablesPaymentImportRowForm: FormGroup;
  formErrors: any = {};
  noteControl: FormControl;
  transferAmountControl: FormControl;
  transferTitleControl: FormControl;
  receivablesBalanceOldControl: FormControl;
  receivablesBalanceNewControl: FormControl;
  processingRequest = false;


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private receivablesPaymentImportRowService:  ReceivablesPaymentImportRowService,
    private snackBar: MatSnackBar,
    private router: Router,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private auth: AuthService,
  ) {
    this.userPermissions = this.auth.getUserPermissions();
    this.receivablesPaymentImportRowForm = this.fb.group({
      receivablesBalanceOld: this.receivablesBalanceOldControl = fb.control('', [Validators.required]),
      receivablesBalanceNew: this.receivablesBalanceNewControl = fb.control('', [Validators.required]),
      transferTitle: this.transferTitleControl = fb.control('', [Validators.required]),
      transferAmount: this.transferAmountControl = this.fb.control('', [Validators.required]),
      note: this.noteControl = fb.control(''),
    });
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  save(): void {
    if (!this.receivablesPaymentImportRowForm.valid) {
      this.receivablesPaymentImportRowForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }
    this.receivablesPaymentImportRowService.sendFormTransfer(this.receivablesPaymentImportRowForm.getRawValue()
    )
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snackBar.open('Pomyślnie przeksięgowano kwotę', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.router.navigate(['/naleznosci/wplaty/szczegoly', response.uuid]);
      }, (error: HttpErrorResponse) => {

        if (error.status === 400) {
          this.snack.open(error.error.error.text, '400', {duration: 2000});
        } else {
          this.snack.open('Podczas przeksięgowania wystąpił błąd', error.status.toString(), {
            duration: 2000,
          });
        }
      });
  }

  cancel(): void {
    this.router.navigate(['/naleznosci/wplaty/rozliczone']);
  }
}
